import { gql, useQuery } from "@apollo/client";
import { Grid } from "@mui/material";
import { ErrorComponent } from "@src/components";
import { DetailPageHeader } from "@src/components/headers/DetailPageHeader";
import LoadingComponent from "@src/components/LoadingComponent";
import { type GQLPurchaseAdminQuery, type GQLPurchaseAdminQueryVariables } from "@src/graphql.generated";
import { type FC, type PropsWithChildren } from "react";

import CameraInformation from "./CameraInformation";
// eslint-disable-next-line @comet/no-private-sibling-import
import { purchaseFragment } from "./fragments.gql";
import PackageInformation from "./PackageInformation";
import PurchaseInformation from "./PurchaseInformation";
import UserInformation from "./UserInformation";

const purchaseQuery = gql`
    query PurchaseAdmin($id: ID!) {
        licenceAdmin(id: $id) {
            ...PurchaseFragment
        }
    }
    ${purchaseFragment}
`;

interface Props {
    id: string;
}

export const ViewPurchase: FC<PropsWithChildren<Props>> = ({ id }) => {
    const { data, error, loading } = useQuery<GQLPurchaseAdminQuery, GQLPurchaseAdminQueryVariables>(purchaseQuery, { variables: { id } });

    if (error) {
        return <ErrorComponent />;
    }

    if (loading || !data) {
        return <LoadingComponent />;
    }

    return (
        <>
            <DetailPageHeader />
            <Grid container spacing={4}>
                <Grid size={6}>
                    <Grid container spacing={4}>
                        <Grid size={12}>
                            <PurchaseInformation licenceAdmin={data.licenceAdmin} />
                        </Grid>
                        <Grid size={12}>
                            <PackageInformation licenceAdmin={data.licenceAdmin} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={6}>
                    <Grid container spacing={4}>
                        <UserInformation licenceAdmin={data.licenceAdmin} />
                        <Grid size={12}>
                            <CameraInformation licenceAdmin={data.licenceAdmin} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};
